import * as React from 'react';
import OrderDetailRequested from '../../../application/order/events/OrderDetailRequested';
import { Link } from 'react-router-dom';
import ViewOrder from './ViewOrder';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../../application/core/DispatchProps';
import { RouteComponentProps } from 'react-router';
import ApplicationState from '../../../application/core/State';

interface MatchParams {
    orderId: string;
}

interface Props extends RouteComponentProps<MatchParams>, DispatchProps, StateProps {
    goBackLink: JSX.Element;
}

interface StateProps {
    customerId: string;
}

class Order extends React.PureComponent<Props> {
    public componentDidMount(): void {
        this.props.dispatch(new OrderDetailRequested(this.props.match.params.orderId, this.props.customerId));
    }

    public render(): JSX.Element {
        return (
            <ViewOrder
                goBackLink={
                    <Link to="/orders-history" className="order-history">
                        {' '}
                        &larr; Order history
                    </Link>
                }
            />
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    customerId: state.user.customerId
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Order);



// WEBPACK FOOTER //
// ./src/view/order/details/Order.tsx